import React from 'react';
import ReportViewer from "./base/ReportViewer";

const AchalandageEffectuePeriode = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"AchalandageEffectuePériode"}/>
        </div>
    );
}
export default AchalandageEffectuePeriode;